import React, { FunctionComponent } from 'react'
import { BoldText } from '../../../theme/typography'
import * as S from './styled'

export enum AlertType {
  Success = '#d4edda',
  Error = '#f8d7da',
  Warning = '#fff3cd',
  Info = '#d1ecf1',
}

type OwnProps = {
  type: AlertType
  message: string
  LinkComponent?: any
  to?: string
  lcText?: string
}

type Props = OwnProps

const Alert: FunctionComponent<Props> = ({ type, message, LinkComponent, to, lcText }) => {
  return (
    <>
      <S.Alert bgColor={type}>
        <BoldText>
          {message} {LinkComponent && <LinkComponent to={to}>{lcText}</LinkComponent>}
        </BoldText>
      </S.Alert>
    </>
  )
}

export default Alert
